import { recipients } from './recipients';

export const page_import = {
  namespaced: true,
  modules: {
    recipients
  }
};
